import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';

/** A labelled switch with a one-line hint (the mockup's toggle rows). */
export const SwitchRow = ({
  label,
  hint,
  checked,
  disabled,
  onChange,
}: {
  label: string;
  hint: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}): ReactElement => (
  <Box
    component="label"
    sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1, cursor: 'pointer' }}
  >
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      slotProps={{ input: { 'aria-label': label } }}
    />
    <Box sx={{ pt: 0.75 }}>
      <Typography variant="body2" fontWeight={600}>
        {label}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {hint}
      </Typography>
    </Box>
  </Box>
);
